import { Component, computed, inject, Input } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MatListItem, MatNavList } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { CockpitService } from '../../../../core/services';
import { AuthStore, SelectedCustomerStore } from '../../../../core/stores';
import * as Paths from '../../../../core/constants';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FeatureFlag } from '../../../../core/models';
import { FeatureFlagStore } from '../../../../core/stores/feature-flag.store';

@Component({
  selector: 'dbx-customer-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, MatNavList, MatListItem, MatIcon, TranslatePipe, MatTooltipModule],
  templateUrl: './customer-sidebar.component.html',
  styleUrl: './customer-sidebar.component.scss',
})
export class CustomerSidebarComponent {
  @Input() isCollapsed = false;
  private readonly router = inject(Router);
  private readonly authStore = inject(AuthStore);
  private readonly selectedCustomerStore = inject(SelectedCustomerStore);
  private readonly cockpitService = inject(CockpitService);
  private readonly featureFlagStore = inject(FeatureFlagStore);

  readonly Paths = Paths;

  protected readonly needsCustomerIdInUrl = computed(() => {
    const user = this.authStore.user();
    const selectedCustomer = this.selectedCustomerStore.selectedCustomer();
    return this.cockpitService.isCustomer() && selectedCustomer !== null && !user?.isUser;
  });

  protected readonly currentCustomerId = computed(() => {
    return this.selectedCustomerStore.selectedCustomer()?.id;
  });

  protected readonly showConfigurations = computed(() =>
    this.featureFlagStore.isAnyFeatureVisible([FeatureFlag.BREACH_LENSE, FeatureFlag.IDENTECO]),
  );

  isUrlActive(path: string[], exact = false): boolean {
    return this.router.isActive(this.router.createUrlTree(path), {
      paths: exact ? 'exact' : 'subset',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }
}
